import { z } from "zod";

export const FigmaFile = z.object({
  id: z.string(),
  name: z.string(),
  lastModifiedAt: z.coerce.date(),
  thumbnailUrl: z.string().optional(),
});

export type FigmaFile = z.infer<typeof FigmaFile>;
